import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-signflow',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `

    <div class="form-row">
      <label>
        {{Yii.t('app', 'Include in Sign flow')}}
      </label>
      <div>
        <p-checkbox [(ngModel)]="fsvc.form.includeInSignWizard" binary="true"/>
      </div>
    </div>

    <div class="form-row">
      <label>
        {{Yii.t('app', 'To Fill No More Than Once')}}
      </label>
      <div>
        @if (!fsvc.form.isHTMLForm) {
          <p-checkbox [(ngModel)]="fsvc.form.toFillOnce" binary="true"/>
        } @else {
          <div class="alert alert-info inline" style="margin: 0">Not available for HTML forms yet</div>
        }
      </div>
    </div>

    <div class="form-row">
      <label>
        {{Yii.t('app', 'Self Provision Template')}}
      </label>
      <div>
        <p-checkbox [(ngModel)]="fsvc.form.selfProvisionTemplate" binary="true"/>
      </div>
    </div>
  `
})
export class FormSignflowComponent {
  Yii = Yii;

  constructor(public fsvc: FormService) {
  }
}
